import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ErrorProps {
	title?: string;
	message?: string;
	retry?: () => void;
}

export function GenericError({
	title = "We hit a problem",
	message = "Something went wrong on our end. Please try again.",
	retry,
}: ErrorProps) {
	return (
		<div className="container flex items-center justify-center min-h-[400px]">
			<Card className="w-full max-w-md">
				<CardHeader>
					<CardTitle className="text-center">{title}</CardTitle>
				</CardHeader>
				<CardContent className="space-y-4">
					<p className="text-center text-muted-foreground">{message}</p>
					{retry && (
						<div className="flex justify-center">
							<Button onClick={retry}>Try Again</Button>
						</div>
					)}
				</CardContent>
			</Card>
		</div>
	);
}
